var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.901 0L15.157 13.743 1.414 0 0 1.414l13.743 13.744L0 28.901l1.414 1.414 13.743-13.743 13.744 13.743 1.414-1.414-13.743-13.743L30.315 1.414z","fill":"#44B1EC","fillRule":"evenodd"}));
}

Close.defaultProps = {"width":"31","height":"31"};

module.exports = Close;

Close.default = Close;
